import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setActs, setLoadActs } from 'store/models/invoiceDetail';

const fetchActs = (invoiceId, from, to) => {
    return (dispatch) => {
        dispatch(setLoadActs(true));
        const queryStr = urlParser.stringify({
            from: formatDate(from),
            to: formatDate(to),
        });
        fetcher.get(`/api/v1/acts/by_invoice/${invoiceId}?${queryStr}`).then((acts) => {
            dispatch([setLoadActs(false), setActs(acts)]);
        });
    };
};

export default fetchActs;
